/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 *
 *
 */

import React from 'react';
import EnhancedTable from '../commons/EnhancedTable';

export default function Sinks() {
    const [pageInfo] = React.useState({
        pageId: "sinks",
        title: "Sinks",
        headCells: [
            {id: 'name', label: 'Stream Name'},
            {id: 'appName', label: 'Application Name'},
            {id: 'nodes', label: 'Nodes'},
            {id: 'type', label: 'Type'},
            {id: 'si_artifact_status', label: 'Enabled / Disabled'}
        ],
        tableOrderBy: 'name'
    });
    return <EnhancedTable pageInfo={pageInfo}/>
}
